import { createTheme } from '@mui/material/styles';

// Color palette from the Knack Shop logo
const theme = createTheme({
  palette: {
    primary: {
      main: '#E0336F', // Bright pink from logo
      light: '#E65C8B',
      dark: '#B32857',
    },
    secondary: {
      main: '#8B3162', // Purple-pink from logo text
      light: '#A55C83',
      dark: '#6F274E',
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFF5F8', // Very light pink for paper surfaces
    },
    text: {
      primary: '#2C2C2C',
      secondary: '#666666',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#E0336F', // Bright pink from logo
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 25,
          textTransform: 'none',
          fontWeight: 500,
          padding: '8px 24px',
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: '#B32857',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        },
      },
    },
  },
});

export default theme;
